<app-header></app-header>
<main class="pages">
    <!--PAGE Hero Section -->
    <section class="gradient-light">
        <div class="container pt-lg-5">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <h1 alt="Market Analysis Survey" class="h1-title mt-3">Field Survey & Market Research</h1>
                    <h4 class="h2-title mt-lg-4 mt-2">
                        Ask, analyze and act swiftly to take your business to new heights.
                    </h4>
                    <p class="sub-text mt-3 text-justify">Field Survey and Market Research plays a crucial role in developing your marketing strategies by gathering important information and useful insights from different vertices in the market. You get an understanding of the consumer buying
                        behaviour, the current market trends, competition’s actions and more.These survey solutions can be used to make evidence based decisions.
                    </p>
                    <div class="mt-lg-5">
                        <a title="" class="btn btn-lg btn-success px-4 text-uppercase  mr-lg-2" data-toggle="modal" data-target="#callBack" id="callback">Request a Demo</a>
                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="page-banner-img">
                        <img class="img-fluid" alt="market Research" title="" src="assets/market-research.svg">
                    </div>
                </div>
            </div>
        </div>
    </section>


    <!-- <section >
        <div class="container">
            <div class="col-md-12">
                <div class="featured card border-0 shadow mt-lg-5">
                    <div class="card-body">
                        <h2 class="text-center headings mb-4">Field Survey & Market Research</h2>
                        <p class="text-center sub-text">Our Application helps you in evaluating your customer's requirement and preference, which therefore results in customer retention and new ones onboard. It provides a deeper understanding of your customers along with competitors.
                            Knowledge of market intelligence and environment can aid in budding of new business opportunities and minimizing risk while making key verdicts. </p>

                    </div>
                </div>
            </div>
        </div>
    </section> -->


    <section class="solutions py-lg-5">
        <div class="container pb-lg-5">
            <div class="col-md-12">
                <h4 class="section-title font-weight-bold text-center mb-4">CViewSurvey provides you valuable <br class="d-none d-lg-block"> insights into areas like:</h4>
            </div>
            <div class="solution-points">
                <ul class="nav nav-tabs tab-titles">
                    <li class="tablinks active">
                        <a class="nav-link" data-id="#Pd">
                            <span class="sol-icon">
                                <img src="assets/product-development.svg" alt="Target Audience">
                            </span>
                        </a>
                        <h6 class="sol-title  text-center">New Product Development</h6>
                    </li>

                    <li class="tablinks">
                        <a class="nav-link" data-id="#Ba">
                            <span class="sol-icon">
                                <img src="assets/brand-awareness.svg" alt="Brand Awareness">
                            </span>
                        </a>
                        <h6 class="sol-title  text-center">Brand Awareness</h6>
                    </li>

                    <li class="tablinks">
                        <a class="nav-link" data-id="#Pf">
                            <span class="sol-icon">
                                <img src="assets/product-feedback.svg" alt="Product Feedback">
                            </span>
                        </a>
                        <h6 class="sol-title  text-center">Product Feedback</h6>
                    </li>

                    <li class="tablinks">
                        <a class="nav-link" data-id="#Ta">
                            <span class="sol-icon">
                                <img src="assets/target-audience.svg" alt="Target Audience">
                            </span>
                        </a>
                        <h6 class="sol-title  text-center">Target Audience</h6>
                    </li>

                    <li class="tablinks">
                        <a class="nav-link" data-id="#Cb">
                            <span class="sol-icon">
                                <img src="assets/customer-behaviour.svg" alt="customer behavior">
                            </span>
                        </a>
                        <h6 class="sol-title  text-center">Customer Behaviour</h6>
                    </li>

                    <li class="tablinks">
                        <a class="nav-link" data-id="#Ca">
                            <span class="sol-icon">
                                <img src="assets/competitor-analysis.svg" alt="Competitor Analysis">
                            </span>
                        </a>
                        <h6 class="sol-title  text-center">Competitor Analysis</h6>
                    </li>

                    <li class="tablinks">
                        <a class="nav-link" data-id="#Cr">
                            <span class="sol-icon">
                                <img src="assets/client-retention.svg" alt="client retention">
                            </span>
                        </a>
                        <h6 class="sol-title  text-center">Customer Retention</h6>
                    </li>
                </ul>


                <div class="pt-2 pb-3 pb-lg-0">
                    <div id="Pd" class="tab-content" style=display:block>
                        <div>
                            From testing idea to concept development and business analysis till product development, all stages are vital in NPD, and understanding each stage thoroughly can determine the success rate of your product or service.
                        </div>
                    </div>

                    <div id="Ba" class="tab-content">
                        <div>
                            Creating awareness is a crucial step in distinguishing your brand from the competitors. To give customers a better brand experience, a business has to be proactive in building its reputation. These surveys can help you understand the level of consumer
                            consciousness towards your brand.

                        </div>
                    </div>

                    <div id="Pf" class="tab-content">
                        <div>
                            Show your customers that you value their opinions and feedback with the help of the product feedback survey.These surveys will help refine product experiences for the customers. Their perceptions about your product can help improve on areas such as quality,
                            ease of use, ability to solve their problems etc.
                        </div>
                    </div>

                    <div id="Ta" class="tab-content">
                        <div>
                            Recognizing the target audience and catering to their needs, can help a business gain traction early in their journey. You can develop your business’s marketing and communicating strategies accordingly. With the help of market research survey, your business
                            can reach the correct audience at the correct time.

                        </div>
                    </div>

                    <div id="Cb" class="tab-content">
                        <div>
                            Customers are King, in order to be successful in any endeavour, it is of foremost importance to know your customer and their behaviour pattern with regards to your product. These survey solutions will help you understand the underlying motives behind
                            a customers purchases that can lead to better and organized decision making.

                        </div>
                    </div>

                    <div id="Ca" class="tab-content">
                        <div>
                            A competitive analysis helps you learn the ins and outs of how your competition works. It is a strategy where you can identify your major competitors and research about their products, sales, and marketing strategies. By doing this, you can create solid
                            business strategies that improve upon your competitor's.

                        </div>
                    </div>

                    <div id="Cr" class="tab-content">
                        <div>
                            Understanding your customer behaviour or your competitor’s strategies can majorly impact your customer retention ability. Higher customer retention will mean your customers will continue to buy from you in some way and not defect to another product or
                            business, or to non-use entirely.

                        </div>
                    </div>
                </div>


                <!-- <div class="alert alert-success blockquote mt-lg-5" role="alert">
                    We help you obtain a better perspective and understanding regarding your market and customers, this survey makes sure that your firm stays ahead in the competition. This plays an important role in minimizing the potential risks of your organization.

                </div> -->

            </div>
        </div>
    </section>

    <section class="bg-primary py-lg-5 mt-lg-5 position-relative">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="solution-video">
                        <!-- <video class="embed-responsive embed-responsive-16by9" autoplay [muted]="'muted'" controls loop>
                        <source width="560" height="315" class="embed-responsive-item" src="assets/video/how-cview-works.mp4" type="video/mp4">
                        Your browser does not support the video tag.
                      </video> -->
                        <iframe width="580" height="335" [src]="safeURL" frameborder="0" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </section>

</main>
<app-footer></app-footer>